import * as React from "react";
import {DateRange} from "../../../../../../components/rangeddatepicker/RangedDatePickerController";
import {DashboardPopupController} from "../../CoffeeMachineDashboard";
import {NewMaintenanceForm, NewMaintenanceFormData} from "./NewMaintenanceForm";

import "./NewMaintenanceInfoPopup.scss";
import {VeBoxModal} from "../../../../../../components/modal/VeBoxModal";

export interface JSONNewMaintenancePopupTexts {
    title: string;
    cancel: string;
    add: string;
    dateLabel: string;
}

export interface JSONDeleteMaintenancePopupTexts {
    title: string;
    cancel: string;
    add: string;
    dateLabel: string;
    revertMaintenance: string;
}

export interface NewMaintenanceInfoPopupProps {
    onAdd: (info: NewMaintenanceFormData) => boolean;
    onCancel: () => void;
    texts: JSONNewMaintenancePopupTexts;
    dateInterval?: DateRange;
}

export class NewMaintenanceInfoPopup
    extends React.Component<NewMaintenanceInfoPopupProps, any> {

    private info: NewMaintenanceFormData;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    public render() {
        return (
            <VeBoxModal style={{width: 400}}>
                <VeBoxModal.Header
                    title={this.props.texts.title}
                    onClose={this.cancelPopup}
                />
                <VeBoxModal.Section>
                    {this.props.dateInterval
                        ? <NewMaintenanceForm
                            onDataChange={this.infoHasChanged}
                            dateLabel={this.props.texts.dateLabel}
                            dateInteval={this.props.dateInterval}
                        />
                        : <div className={"new-maintenance-popup-form"}>
                            <div className={"new-maintenance-popup-form-date"}>
                                <label>{this.props.texts.dateLabel}</label>
                            </div>
                        </div>
                    }
                </VeBoxModal.Section>
                <VeBoxModal.StandardActions
                    // submitText={this.props.texts.add}
                    canSubmit={!this.state.loading}
                    // cancelText={this.props.texts.cancel}
                    onSubmit={this.addInfo}
                    onCancel={this.cancelPopup}
                />
            </VeBoxModal>
        );
    }

    private infoHasChanged = (newInfo) => {
        this.info = newInfo;
    }

    private cancelPopup = () => {
        DashboardPopupController.closePopup();
        this.props.onCancel();
    }

    private addInfo = () => {
        const isAdded: boolean = this.props.onAdd(this.info);
        if (isAdded) {
            DashboardPopupController.closePopup();
        }
    }
}
